export const WHITELIST_TYPE: any = {
  'list-whitelist': 'Manage whitelist',
  'list-courier': 'Manage courier',
  'pickup-crrque': 'Pickup CRRQUE',
  'pickup-corporate': 'Pickup Corporate',
  'pickup-crrnfd': 'Pickup CRRNFD',
  'pickup-dox': 'Pickup DOX',
  'pickup-crrotw': 'Pickup CRROTW',
  'pickup-crrpic': 'Pickup CRRPIC',
  'pickup-crrdon': 'Pickup CRRDON',
  'list-stt-pod': 'POD tracker',
  'pickup-radius-validation': 'Pickup validation radius',
  'cancel-validation': 'Cancel validation',
  'manage-cod-payment': 'Kelola pembayaran COD',
  'saldo-adjustment': 'Manual adjust saldo',
  'basic-fee-adjustment': 'Manual adjust basic fee',
  bonus: 'Bonus',
  'list-penghasilan-courier': 'Manage data penghasilan',
}
